import { render, staticRenderFns } from "./SourceDocuments.vue?vue&type=template&id=574ca185&scoped=true&"
import script from "./SourceDocuments.vue?vue&type=script&lang=js&"
export * from "./SourceDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SourceDocuments.vue?vue&type=style&index=0&id=574ca185&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ca185",
  null
  
)

export default component.exports